const dict = () => import('@/views/main/system/dict/Dict.vue')
export default {
  path: '/main/system/dict',
  name: 'system-dict',
  component: dict,
  children: []
}
